module.exports = __webpack_public_path__ + "static/media/home_11.853b4d00.jpg";